import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { appStore } from "@/hooks";


/**
 * Loading bar used in application header.
 */
const __default__ = {
  name: "LoadingBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isLoading = computed(() => appStore.isLoading > 0);

return (_ctx: any,_cache: any) => {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!

  return (isLoading.value)
    ? (_openBlock(), _createBlock(_component_q_linear_progress, {
        key: 0,
        rounded: "",
        size: "sm",
        indeterminate: "",
        class: "nav-gradient",
        "data-cy": "app-loading"
      }))
    : _createCommentVNode("", true)
}
}

})